<sh-box id="service-history-box-1" style="flex-grow:0;" background="surface" layout="vertical" elevation="none" style="height: 100%">

  <sh-box-header id="service-history-box-header-2" slot="header" padding-bottom="0">
    <sh-icon id="service-history-icon-utilities" icon="utilities" size="s" style="margin-left: -2px; margin-right: 4px; cursor: help;"
    (click)="openHelp('Service History')"></sh-icon>
    <sh-text id="service-history-text-4" size="title-1" style="cursor: help;" (click)="openHelp('Service History')">{{ 'serviceHistory.widget.title' | transloco }}</sh-text>
    <!-- <sh-icon id="service-history-icon-information" icon="information" size="s" button [attr.aria-label]="'Information Service History'"></sh-icon> -->
    <sh-dropdown id="service-history-dropdown-6" no-border condensed style="max-width: 120px;" [attr.value]="(selectedRange === 30 ? 'serviceHistory.widget.range.last30Days' : selectedRange === 60 ? 'serviceHistory.widget.range.last60Days' : selectedRange === 90 ? 'serviceHistory.widget.range.last90Days' : selectedRange === 120 ? 'serviceHistory.widget.range.last120Days' : 'serviceHistory.widget.range.last120Days') | transloco">
      <sh-menu-item id="service-history-menu-item-last-30-days" (click)="changeRange(30)" [attr.label]="'serviceHistory.widget.range.last30Days' | transloco" [active]="selectedRange === 30"></sh-menu-item>
      <sh-menu-item id="service-history-menu-item-last-60-days" (click)="changeRange(60)" [attr.label]="'serviceHistory.widget.range.last60Days' | transloco" [active]="selectedRange === 60"></sh-menu-item>
      <sh-menu-item id="service-history-menu-item-last-90-days" (click)="changeRange(90)" [attr.label]="'serviceHistory.widget.range.last90Days' | transloco" [active]="selectedRange === 90"></sh-menu-item>
      <sh-menu-item id="service-history-menu-item-last-120-days" (click)="changeRange(120)" [attr.label]="'serviceHistory.widget.range.last120Days' | transloco"
      [active]="selectedRange === 120"></sh-menu-item>
    </sh-dropdown>
  </sh-box-header>

  <sh-box-section id="service-history-box-section-11" style="height: 100%">

    @if (isLoading) {
      <div
        style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="service-history-spinner-12" size="s"></sh-spinner>
      </div>
    }


    @if (!isLoading) {
      <div style="display: flex; flex-direction: column; gap: 4px;">
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicehistory?.metrics && servicehistory?.totally_down > 0 ) {
              <sh-icon id="service-history-icon-error" icon="error" size="xs" style="cursor: help;"
              (click)="openHelp('Notifications')"></sh-icon>
            }
            @if ((servicehistory?.totally_down === 0 && (servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] === null || servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] === 0)) || servicehistory?.metrics === null) {
              <sh-icon id="service-history-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Notifications')"></sh-icon>
              
            }
           
       
            @if (servicehistory?.totally_down === 0 && servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] !== null && servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] !== 0) {
              <sh-icon id="service-history-icon-warning"
                icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help;"
              (click)="openHelp('Notifications')"></sh-icon>
            }
            <sh-text id="service-history-text-16" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Notifications')">{{ 'serviceHistory.widget.notifications' | transloco }}</sh-text>
          </div>
          @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] !== 0 && servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open'] !== null) {
            <div (click)="onMaximize('Notifications')"
              [ngClass]="'custom-tag'">
            {{servicehistory?.metrics?.time_windows[selectedRange+'']['notifications_open']}} {{ 'serviceHistory.widget.openCurrent' | transloco }}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicehistory?.metrics?.time_windows[selectedRange+'']['spare_parts_used'] === 0 || servicehistory?.metrics === null) {
              <sh-icon id="service-history-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Spare Parts Used')"></sh-icon>
            }
            @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['spare_parts_used'] !== 0) {
              <sh-icon id="service-history-icon-warning"
                icon="warning" size="xs" color="var(--warning-icon-color)" style="cursor: help;"
              (click)="openHelp('Spare Parts Used')"></sh-icon>
            }
            <sh-text id="service-history-text-19" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Spare Parts Used')">{{ 'serviceHistory.widget.sparePartsUsed' | transloco }}</sh-text>
          </div>
          @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['spare_parts_used'] !== 0) {
            <div (click)="onMaximize('Spare Parts Used')"
              [ngClass]="'custom-tag'">
            {{servicehistory?.metrics?.time_windows[selectedRange+'']['spare_parts_used'] + ''}}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] === 0 || servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] === null || servicehistory?.metrics === null) {
              <sh-icon id="service-history-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Site Visits')"></sh-icon>
            }
            @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] !== null && servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] !== 0) {
              <sh-icon id="service-history-icon-warning"
                icon="warning" size="xs" color="var(--warning-icon-color)" style="cursor: help;"
              (click)="openHelp('Site Visits')"></sh-icon>
            }
            <sh-text id="service-history-text-22" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Activities')">{{ 'serviceHistory.widget.activities' | transloco }}</sh-text>
          </div>
          @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] !== null && servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] !== 0) {
            <div (click)="onMaximize('Activities')"
              [ngClass]="'custom-tag'">
            {{servicehistory?.metrics?.time_windows[selectedRange+'']['site_visits'] + ''}}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] === 0 || servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] === null || servicehistory?.metrics === null) {
              <sh-icon id="service-history-icon-success" icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Proactive Alarms')"></sh-icon>
            }
            @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] !== null && servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] !== 0) {
              <sh-icon id="service-history-icon-warning"
                icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help;"
              (click)="openHelp('Proactive Alarms')"></sh-icon>
            }
            <sh-text id="service-history-text-25" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Proactive Alarms')">{{ 'serviceHistory.widget.proactiveAlerts' | transloco }}</sh-text>
          </div>
          @if (servicehistory?.metrics && servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] !== 0 && servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] !== null)  {
            <div (click)="onMaximize('Proactive Alarms')"
              [ngClass]="'custom-tag'">
            {{servicehistory?.metrics?.time_windows[selectedRange+'']['alarms'] + ''}}</div>
          }
        </div>
      </div>
    }



    @if (isError) {
      <sh-empty-state id="service-history-empty-state-error-retrieving-data" [attr.label]="'serviceHistory.widget.error' | transloco" icon="error" icon-color="#ebebe"></sh-empty-state>
    }

    @if (isEmpty) {
      <sh-empty-state id="service-history-empty-state-no-data-found" [attr.label]="'serviceHistory.widget.empty' | transloco" icon="information" icon-color="#ebebe"></sh-empty-state>
    }

  </sh-box-section>
  @if (!isLoading && servicehistory) {
    <sh-box-footer id="service-history-box-footer-28" slot="footer" padding-top="0" padding-bottom="1rem">
      @if (getDeviceType() !== 'phone') {
        <sh-button id="service-history-button-details" [icon]="checkWidgetIcon()" icon-position="right" icon-size="s"
        [attr.label]="'serviceHistory.widget.details' | transloco" layout="compact" color="secondary" size="s" (click)="onMaximize(null)"></sh-button>
      }
    </sh-box-footer>
  }

</sh-box>